export const shouldRequestSponsoredProducts = ({
  sponsoredProductIds,
  isSorted,
  isServerRendered,
}) => !!sponsoredProductIds && !isSorted && isServerRendered;
